import { render, staticRenderFns } from "./NoContentView.vue?vue&type=template&id=4a2f90c4&scoped=true"
import script from "./NoContentView.vue?vue&type=script&lang=js"
export * from "./NoContentView.vue?vue&type=script&lang=js"
import style0 from "./NoContentView.vue?vue&type=style&index=0&id=4a2f90c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2f90c4",
  null
  
)

export default component.exports